import React, { useContext } from 'react'
import courseContext from '../../../Helper/Courses'
import { Breadcrumbs } from '../../../AbstractElements'
import { Container } from 'reactstrap'
import { getFullCourseName } from '../../../utils/course'
import Attendance from '../../pages-partial/AttendanceManagement'

const AttendanceManagement = () => {
  const { activeCourse } = useContext(courseContext)

  return (
    <>
      <Breadcrumbs mainTitle={getFullCourseName(activeCourse)} />
      <Container fluid={true} className="dashboard-default">
        <Attendance />
      </Container>
    </>
  )
}

export default AttendanceManagement